import { apiClient } from './client';

export interface TelegramSettings {
  is_configured: boolean;
  chat_id: string | null;
  bot_token_masked: string | null;
}

export interface TelegramSettingsRequest {
  bot_token: string;
  chat_id: string;
}

export const branchSettingsApi = {
  getTelegram: async (): Promise<TelegramSettings> =>
    (await apiClient.get<TelegramSettings>('/v1/branch-settings/telegram')).data,

  updateTelegram: async (data: TelegramSettingsRequest): Promise<TelegramSettings> =>
    (await apiClient.put<TelegramSettings>('/v1/branch-settings/telegram', data)).data,

  testTelegram: async (data: TelegramSettingsRequest): Promise<{ success: boolean }> =>
    (await apiClient.post<{ success: boolean }>('/v1/branch-settings/telegram/test', data)).data,

  revokeTelegram: async (): Promise<TelegramSettings> =>
    (await apiClient.delete<TelegramSettings>('/v1/branch-settings/telegram')).data,
};
